import React from "react";
import "./contact.css";

export default function Contact() {
  return (
    <div className="contact">
      <div className="contact-block">
        <div style={{ marginBottom: "20px" }}>
          <h3 style={{ color: "var(--mainColor)", fontWeight: "900", fontSize: "30px", marginBottom: "20px" }}>
            PIXELS2PIXELS
          </h3>
          <p>Cara Dušana 40/32,</p>
          <p>15000 Šabac,</p>
          <p>Srbija</p>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <p>Tel. 069 446 9700</p>
        </div>
        <div>
          <a
            href="mailto:info@pixels2pixels.com"
            style={{ color: "var(--mainColor)", fontWeight: "900", textDecoration: "underline" }}
          >
            info@pixels2pixels.com
          </a>
        </div>
      </div>
    </div>
  );
}
